export interface DemographicField {
  id: string
  label: string
  type: "text" | "email" | "select" | "multi-select"
  required: boolean
  placeholder?: string
  options?: { value: string; label: string }[]
}

export const demographicFields: DemographicField[] = [
  {
    id: "first_name",
    label: "First Name",
    type: "text",
    required: true,
    placeholder: "John",
  },
  {
    id: "last_name",
    label: "Last Name",
    type: "text",
    required: true,
    placeholder: "Smith",
  },
  {
    id: "gender",
    label: "Gender",
    type: "select",
    required: true,
    options: [
      { value: "male", label: "Male" },
      { value: "female", label: "Female" },
    ],
  },
  {
    id: "email",
    label: "Email",
    type: "email",
    required: true,
    placeholder: "john@example.com",
  },
  {
    id: "zipcode",
    label: "Zip Code",
    type: "text",
    required: true,
    placeholder: "90210",
  },
  {
    id: "age",
    label: "Age Range",
    type: "select",
    required: true,
    options: [
      { value: "18-25", label: "18-25" },
      { value: "26-35", label: "26-35" },
      { value: "36-45", label: "36-45" },
      { value: "46-55", label: "46-55" },
      { value: "56-65", label: "56-65" },
      { value: "66+", label: "66+" },
    ],
  },
  {
    id: "ethnicity",
    label: "Ethnicity",
    type: "select",
    required: true,
    options: [
      { value: "american-indian-alaskan-native", label: "American Indian/Alaskan Native" },
      { value: "asian", label: "Asian" },
      { value: "black-african-american", label: "Black/African American" },
      { value: "hispanic-latino", label: "Hispanic/Latino" },
      { value: "middle-eastern-north-african", label: "Middle Eastern/North African" },
      { value: "native-hawaiian-pacific-islander", label: "Native Hawaiian/Pacific Islander" },
      { value: "white-caucasian", label: "White/Caucasian" },
    ],
  },
  {
    id: "marital_family_status",
    label: "Marital/Family Status",
    type: "multi-select",
    required: true,
    options: [
      { value: "single", label: "Single" },
      { value: "married", label: "Married" },
      { value: "divorced", label: "Divorced" },
      { value: "widowed", label: "Widowed" },
      { value: "have-children", label: "Have Children" },
      { value: "no-children", label: "No Children" },
    ],
  },
  {
    id: "employment_status",
    label: "Employment Status",
    type: "select",
    required: true,
    options: [
      { value: "employed", label: "Employed" },
      { value: "unemployed", label: "Unemployed" },
      { value: "retired", label: "Retired" },
    ],
  },
  {
    id: "faith_involvement",
    label: "Current Faith Involvement",
    type: "select",
    required: true,
    options: [
      { value: "none", label: "None" },
      { value: "catholic", label: "Catholic" },
      { value: "baptist", label: "Baptist" },
      { value: "methodist", label: "Methodist" },
      { value: "lutheran", label: "Lutheran" },
      { value: "pentecostal", label: "Pentecostal" },
      { value: "charismatic", label: "Charismatic" },
      { value: "presbyterian", label: "Presbyterian" },
      { value: "reformed", label: "Reformed" },
      { value: "anglican-episcopalian", label: "Anglican/Episcopalian" },
      { value: "adventist", label: "Adventist" },
      { value: "orthodox", label: "Orthodox" },
      { value: "historically-black", label: "Historically Black" },
      { value: "non-denominational-independent", label: "Non-Denominational/Independent" },
    ],
  },
]
